import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HeaderNav from "@/components/landing/HeaderNav";
import HeroSection from "@/components/landing/HeroSection";
import Marquee from "@/components/landing/Marquee";
import AboutSection from "@/components/landing/AboutSection";
import ServicesSection from "@/components/landing/ServicesSection";
import BookSection from "@/components/landing/BookSection";
import PillarsSection from "@/components/landing/PillarsSection";
import ContactSection from "@/components/landing/ContactSection";
import FaqSection from "@/components/landing/FaqSection";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import BackToTop from "@/components/landing/BackToTop";
import CookieBanner from "@/components/landing/CookieBanner";
import PrivacyPolicy from "@/components/landing/PrivacyPolicy";

const Home = () => (
    <>
        <HeaderNav />
        <main>
            <HeroSection />
            <Marquee />
            <AboutSection />
            <ServicesSection />
            <BookSection />
            <PillarsSection />
            <FaqSection />
            <ContactSection />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <BackToTop />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (id.length > 1 && document.querySelector(id)) {
                e.preventDefault();
                lenis.scrollTo(id, { offset: -72 });
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain bg-cream font-sans text-ink antialiased">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacidade" element={<PrivacyPolicy />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
        </div>
    );
}

export default App;
